import * as E from 'fp-ts/Either';
import { useEffect, useState } from 'react';
import { enumerateTypes } from '../api/apps';
import { useAuth } from '../auth/AuthContext';

export const useKnownApps = () => {
  const auth = useAuth();
  const [knownApps, setApps] = useState<string[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!auth?.token) {
      return;
    }
    enumerateTypes(auth.token).then((result) =>
      E.isLeft(result)
        ? setError(result.left.message)
        : setApps(Array.isArray(result.right) ? result.right : [])
    );
  }, [auth?.token]);

  return { knownApps, error };
};
